import { NgModule, CUSTOM_ELEMENTS_SCHEMA, APP_INITIALIZER } from '@angular/core';

import { CommonService } from './services/common.service';
import { SharedComponentConstants } from './shared-module.constants';
import { AppCommonModule } from './../common/app-common.module';
import { CarouselModule, CollapseModule, TabsModule, ModalModule, BsDropdownModule, TypeaheadModule } from 'ngx-bootstrap';
import { ConfigurationService } from './services/configuration.service';
import {CacheService} from './services/cache.service';
import { DataShareService } from './services/data.service';
import { AppMessageService } from '../app-message.service';
import { CartService } from './services/cart.service';
import { ActiveSessionService } from './services/active-session.service';
import { CookieService } from 'ngx-cookie-service';
import { NotificationService } from './services/notification.service';
import { CanActivateNotFoundGuard } from './guards/can-activate-not-found.guard';
import { AloeAroundTheworldService } from '../promotion/services/aloe-around-theworld.service';
import { AuthService } from './services/auth.service';
import { FeatureCanActivateGuard } from './guards/feature-activate.guard';
import { MemberOrderRestrictionService } from './services/member-order-restriction.service';
import { MemberDisplayPriceConfigService } from './services/member-display-price-config.service';
import { SEOService } from './services/seo.service';

export function authServiceFactory(authService: AuthService) {
  return () => authService.init();
}


@NgModule({
  imports: [
    AppCommonModule,
    CarouselModule.forRoot(),
    CollapseModule.forRoot(),
    TabsModule.forRoot(),
    ModalModule.forRoot(),
    TypeaheadModule.forRoot()
  ],
  declarations: SharedComponentConstants.MODULE_COMPONENTS,
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  providers: [
    CommonService,
    CartService,
    ConfigurationService,
    AloeAroundTheworldService,
    CacheService,
    DataShareService,
    ActiveSessionService,
    AppMessageService,
    CookieService,
    NotificationService,
    CanActivateNotFoundGuard,
    FeatureCanActivateGuard,
    MemberOrderRestrictionService,
    MemberDisplayPriceConfigService,
    SEOService,
    AuthService, {
      provide: APP_INITIALIZER,
      useFactory: authServiceFactory, deps: [AuthService], multi: true
    }
  ],
  exports: SharedComponentConstants.MODULE_COMPONENTS
})
export class SharedModule { }
